import Style from "./avatar.module.scss";
import defaultSrc from "../../../assets/images/default-avatar.png";
import classNames from "classnames";

interface AvatarProps {
    url?: string;
    testId?: string;
    className?: string;
    squared?: boolean;
}

export const Avatar = (props: AvatarProps) => {
    return (
        <span 
            style={{backgroundImage: `url(${props?.url || defaultSrc})`}}
            data-testid={`avatar-${props?.testId ? props.testId : "none"}`}
            className={classNames(Style.avatar, {[`${Style.squared}`]: props.squared})}
        />
    )
}